package com.hyperether.goodjob.managers

import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.graphics.toComposeImageBitmap
import org.jetbrains.skia.Data
import org.jetbrains.skia.Image
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

actual class FileManager {
    private val storage = js("window.localStorage")

    actual fun saveFile(fileId: String, data: ByteArray): String {
        val blob = Blob(arrayOf(data), BlobPropertyBag(type = "application/pdf"))
        val url = URL.createObjectURL(blob)

        storage.setItem(fileId, url)
        return url
    }

    actual fun getFilePath(fileId: String): String? {
        return storage.getItem(fileId) as? String
    }

    actual fun getBitmap(fileId: String): BitmapPainter? {
        return null
    }

    actual fun deleteFile(fileId: String): Boolean {
        storage.removeItem(fileId)
        return true
    }

    actual fun getBitmapFromByteArray(byteArray: ByteArray): BitmapPainter? {
        val skiaData = Data.makeFromBytes(byteArray)
        val skiaImage = Image.makeFromEncoded(skiaData.bytes)
        return BitmapPainter(skiaImage.toComposeImageBitmap())
    }
}